// FNP-969 — the console's ONLY write to a SyntheticUser.
//
// ═══ RETIRE IS NOT DELETE, AND THERE IS NO DELETE ═══
//
// `retireSyntheticUser` TOMBSTONES the row: lifecycleStage → DELETED,
// state → TOMBSTONED. The row survives. There is deliberately no
// `deleteSyntheticUser` mutation on the API to call, and this module must never
// grow one — a `SyntheticUser` row MUST outlive the account it describes.
//
// The roster is the only thing distinguishing synthetic activity from organic
// activity: there is no `isSynthetic` flag on `Account`. Purge the rows and that
// separation becomes permanently unanswerable, retroactively, for every report
// that ever needs to exclude test traffic.
//
// ⚠️ The response deliberately does NOT select `secretArn` — same standing rule as
// queries.ts. A mutation response is just as much a render path as a query is, and
// the field points at a Secrets Manager password. `tests/services/noSecretArn.test.ts`
// asserts this file is clean.
//
// The sub-selection is narrow on purpose: the fields the UI must re-render to show
// the row is now a tombstone, and nothing more. Echoing the whole object back would
// let a stale browser tab overwrite fields it never intended to touch (the
// platform's mutation-whitelist rule).
export const retireSyntheticUser = `
   mutation retireSyntheticUser($id: ID!) {
       retireSyntheticUser(id: $id) {
           id
           lifecycleStage
           state
           nextWakeAt
           updated
       }
   }
`;
